import React, { Fragment } from "react";
import ResourceResume from "./ResourceResume";
import CustomHr from "../common/CustomHr";
import MainTitle from "../common/MainTitle";
import { translate } from "utlis/translations/i18n";

const ResourcesResume = ({ resultsDsc, maximum, result }) => {
  return (
    <Fragment>
      <MainTitle text={translate('imagesByPreferenceOrder')} />

      <div className="row margin-bottom-large">
        {resultsDsc.map((result, index) => {
          return (
            <ResourceResume
              key={index}
              rank={index + 1}
              result={result}
              maximum={maximum}
            />
          );
        })}
      </div>
      <p>
        {translate('pcPoints1')} <br />
        {translate('pcPoints2')} 
      </p>
      <p className="margin-bottom-large">
        {translate('pcScore')}
      </p>
      <CustomHr />
    </Fragment>
  );
};

export default ResourcesResume;
